import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { getUserToken } from '../../utilities/helpers';

export const favoritesApi = createApi({
  reducerPath: 'favoritesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.apiV6Config.path + '/user'
  }),
  tagTypes: ['Favorite'],
  endpoints: builder => ({
    getUserFavorites: builder.query({
      query: (muid) => `favorites?muid=${muid}`,
      providesTags: ['Favorite']
    }),
    addUserFavorite: builder.mutation({
      query: ({ muid, body }) => ({
        url: `favorite?muid=${muid}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['Favorite']
    }),
    removeUserFavorite: builder.mutation({
      query: ({ muid, favoriteId }) => ({
        url: `favorite?muid=${muid}&id=${favoriteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Favorite']
    })
  })
})

export const {
  useGetUserFavoritesQuery,
  useAddUserFavoriteMutation,
  useRemoveUserFavoriteMutation
} = favoritesApi;
